import httpClient from '@/http-client'
import config from '../config'

export default {
  create(payload, idempotencyKey) {
    return httpClient
      .post(`${config.apiPrefix}/orders`, payload, {
        headers: {
          'Idempotency-Key': idempotencyKey
        }
      })
      .then(response => response.data)
      .catch(error => Promise.reject(error.response ? error.response.data : error))
  }
}
